// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 19351 ? "a5ce6a92" : chunkId) + "." + {"19351":"c1f7de0082641d15","22346":"1458b2fb4f8656db","53348":"debb6a7356500850","99072":"d08aec21fd465e58"}[chunkId] + ".js";
};